import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import {
  CreditEventReliability,
  CreditEventsRefreshStatus,
  CreditEventType,
} from 'constants/loanApplication';

export const CREDIT_REPORT_EVENT_DATES_TITLE = 'From the credit report';

export const REFRESH_BUTTON_LABEL = 'Refresh from credit report';

export const NO_CREDIT_REPORT_EVENTS_TEXT =
  'No bankruptcy, foreclosure, short sale or deed-in-lieu on the credit report.';

export const CREDIT_REPORT_NOT_READ_TEXT =
  'The credit report hasn’t been read for these events yet. Refresh to read it.';

export const CREDIT_REPORT_DATE_ROWS = [
  {
    key: 'creditBankruptcyFilingDate',
    label: 'Bankruptcy filed',
    eventType: CreditEventType.BANKRUPTCY,
    hasChapter: true,
  },
  {
    key: 'creditBankruptcyDischargeDate',
    label: 'Bankruptcy discharged',
    eventType: CreditEventType.BANKRUPTCY,
  },
  {
    key: 'creditBankruptcyDismissalDate',
    label: 'Bankruptcy dismissed',
    eventType: CreditEventType.BANKRUPTCY,
  },
  { key: 'creditForeclosureDate', label: 'Foreclosure', eventType: CreditEventType.FORECLOSURE },
  { key: 'creditShortSaleDate', label: 'Short sale', eventType: CreditEventType.SHORT_SALE },
  { key: 'creditDeedInLieuDate', label: 'Deed-in-lieu', eventType: CreditEventType.DEED_IN_LIEU },
];

export const EVENT_DATE_FIELDS = ['filedDate', 'dispositionDate', 'eventDate'];

export const REPORT_ID_PREFIX_LENGTH = 8;

export const RELIABILITY_LABEL_VARIANT = {
  [CreditEventReliability.HIGH]: LabelVariant.GREEN,
  [CreditEventReliability.MEDIUM]: LabelVariant.ORANGE,
  [CreditEventReliability.LOW]: LabelVariant.RED,
};

const describeEvents = (count, kind = '') =>
  count ? `${count} ${kind}event${count === 1 ? '' : 's'}` : `no ${kind}events`;

export const REFRESH_STATUS_MESSAGE = {
  [CreditEventsRefreshStatus.REPARSED]: count =>
    `Read the stored credit report again: ${describeEvents(count)} found.`,
  [CreditEventsRefreshStatus.UNCHANGED]: count =>
    `No changes: the credit report still shows ${describeEvents(count)}.`,
  [CreditEventsRefreshStatus.STORED_RESPONSE_NOT_FOUND]: count =>
    `The stored report could not be read again; the dates were rebuilt from ${describeEvents(count, 'saved ')}.`,
  [CreditEventsRefreshStatus.NO_CREDIT_REPORT]: () =>
    'This application has no credit report to read.',
  [CreditEventsRefreshStatus.BORROWER_NOT_ON_CREDIT_REPORT]: () =>
    'This borrower is not on the credit report.',
};

export const REFRESH_FALLBACK_MESSAGE = 'The credit report was read again.';
